import {apiServiceCatalogServiceByID} from './../../apis/api'
const state = {
    services:[]
};
const mutations = {
    addService(state,item){
        state.services.push(item);
    },
    deleteService(state,resID){
        var val = state.services.findIndex((item) => item.resID == resID);
        if(val!=-1){
            state.services.splice(val,1);
        }
    },
    deleteAllServices(state){
      state.services = []
    }
}
const actions = {
    addS({commit},id){
        apiServiceCatalogServiceByID(id).then(function(result){
            if(result.data.resultInfo.data[0].serviceInfos[0].type.value=='数据服务'){
                commit("addService",result.data.resultInfo.data[0].serviceInfos[0])
            }
        })
    },
    deleteS({commit},id){
        apiServiceCatalogServiceByID(id).then(function(result){
            if(result.data.resultInfo.data[0].serviceInfos[0].type.value=='数据服务'){
                commit("deleteService",result.data.resultInfo.data[0].serviceInfos[0])
            }
        })
    }
}
export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/service.js